import React, { useCallback } from 'react'
import Bem from 'app/utils/bem-helper'
import { ErrorMessage, Field } from 'formik'

export default function SupportType({
  onChange,
  values,
  setFieldValue,
  setSupportType,
  fields = [],
  setRedirectTo
}) {
  const b = Bem('contact-form')
  const updateValues = useCallback(
    (e, field) => {
      if (field.redirectToUrl) {
        setFieldValue('businessType', '')
      }
      setRedirectTo(field.redirectToUrl || null)
      if (
        e.target.value.match(/sales/i) &&
        values?.businessType?.match(
          /small and medium business|enterprise\/franchise|hotels/i
        ) === null
      ) {
        setFieldValue('businessType', '')
      }

      setSupportType(e.target.value)
    },
    [setSupportType]
  )

  return (
    <>
      {fields?.map(field => (
        <label
          className={b.e('radio-label').m({ single: true }).classes()}
          htmlFor={field.id}
          key={field.id}
        >
          <Field
            type="radio"
            name="supportType"
            value={field.label}
            id={field.id}
            onChange={e => {
              onChange(e)
              updateValues(e, field)
            }}
          />
          <span>{field.label}</span>
        </label>
      ))}

      <ErrorMessage
        name="supportType"
        component="div"
        className={b.e('error').classes()}
      />
    </>
  )
}
